/**
 * `directus_users.promoter` is generated as `any` because the relation starts in a system
 * collection. Read without expanding it, the field holds the id of the linked promoter.
 */
export const getPromoterId = (user: { promoter?: unknown } | null | undefined): string | number | undefined => {
  const promoter = user?.promoter;

  return typeof promoter === 'string' || typeof promoter === 'number' ? promoter : undefined;
};
